import type { FC } from 'react';

import SessionAvailabilityPill from '@/components/SessionAvailabilityPill';
import type { Props } from '@/components/TreatmentGroupDetailSections/components/SessionCard/types';
import { DAY_LABELS } from '@/constants/dayOfWeek';
import { Typography } from '@/ui';
import { cn } from '@/ui/lib/utils';
import { formatTimeOfDay, getTimeZoneAbbreviation } from '@/utils/dates';

const SessionCard: FC<Props> = ({ memberFirstName = 'this member', session }) => (
  <div
    className={cn(
      'rounded-lg border px-3 py-2',
      session.is_within_person_availability
        ? 'border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950/40'
        : 'border-uniform-gray-200 bg-uniform-gray-50 dark:border-uniform-gray-700 dark:bg-uniform-gray-800'
    )}>
    <Typography variant="body">
      <span className="font-medium">{DAY_LABELS[session.display_day_of_week]}</span>{' '}
      <span className="text-uniform-gray-500">
        {formatTimeOfDay(session.display_start_time)}–{formatTimeOfDay(session.display_end_time)}{' '}
        {getTimeZoneAbbreviation(session.display_timezone)}
      </span>
    </Typography>
    <Typography variant="body" muted as="span">
      <SessionAvailabilityPill
        isWithinPersonAvailability={session.is_within_person_availability}
        memberFirstName={memberFirstName}>
        {session.staff_name}
      </SessionAvailabilityPill>
    </Typography>
  </div>
);

export default SessionCard;
